import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import RadioInput from '../../../../../../../../components/inputs/RadioInput'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B3_FORM_INITIAL_VALUES } from '../constants'

interface Props {}

export const B32OverallAccessibilityConditions: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<typeof B3_FORM_INITIAL_VALUES>
  return (
    <FormSectionTwoColumns
      sectionKey="b3.overallAccessibilityConditions"
      title="B.3.2 Celkové řešení podmínek přístupnosti"
      infoContent={
        <div className="text-left">
          <ol className="list-decimal pl-5 mt-3 font-bold">
            <li>
              Celkové řešení přístupnosti objektu
              <ul className="list-disc pl-5">
                <li className="mt-3">
                  Přístup pro osoby s omezenou schopností pohybu a orientace:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Popis bezbariérového přístupu do budovy (např. nájezdové rampy, výtahy,
                      plošiny).
                    </p>
                    <p>Šířka a sklon ramp, manipulační prostory.</p>
                    <p>
                      Bezbariérové řešení hlavního vstupu, vnitřních komunikací, dveří, schodišť,
                      zábradlí, výtahů.
                    </p>
                    <p>Přístupnost sanitárních zařízení (např. WC, umyvadla, sprchy).</p>
                  </div>
                </li>
                <li className="mt-3">
                  Další požadavky na přístupnost:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Označení a navigace pro osoby se zrakovým nebo sluchovým postižením (např.
                      hmatové prvky, akustické signály, indukční smyčky).
                    </p>
                    <p>
                      Zajištění přístupnosti parkovacích míst pro osoby s omezenou pohyblivostí.
                    </p>
                  </div>
                </li>
              </ul>
            </li>

            <li className="mt-3">
              Specifikace částí, které podléhají požadavkům na přístupnost
              <ul className="list-disc pl-5">
                <li className="mt-3">
                  Výčet konkrétních prostor a zařízení v budově:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>Vstupní prostory (dveře, vestibuly, recepce).</p>
                    <p>Komunikační prostory (chodby, schodiště, výtahy).</p>
                    <p>Hygienická zařízení.</p>
                    <p>Pracovní a společenské prostory (pokud jsou určeny k veřejnému užívání).</p>
                  </div>
                </li>
                <li className="mt-3">
                  Odkazy na právní předpisy a normy:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Např. vyhláška č. 398/2009 Sb., o obecných technických požadavcích
                      zabezpečujících bezbariérové užívání staveb.
                    </p>
                    <p>Specifikace splnění ČSN týkajících se přístupnosti.</p>
                  </div>
                </li>
              </ul>
            </li>

            <li className="mt-3">
              Dopady předčasného užívání
              <ul className="list-disc pl-5">
                <li className="mt-3">
                  Rizika spojená s nedokončením některých částí stavby:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Např. pokud nebude dokončena nájezdová rampa, přístup pro osoby s omezenou
                      pohyblivostí nebude zajištěn.
                    </p>
                    <p>Pokud nebude zprovozněn výtah, omezený přístup do vyšších podlaží.</p>
                  </div>
                </li>
                <li className="mt-3">
                  Provizorní opatření pro předčasné užívání:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>Např. dočasné řešení přístupu, označení nebezpečných zón.</p>
                  </div>
                </li>
              </ul>
            </li>

            <li className="mt-3">
              Dopady zkušebního provozu
              <ul className="list-disc pl-5">
                <li className="mt-3">
                  Zajištění přístupnosti během zkušebního provozu:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Testování funkčnosti výtahů, ramp, akustických a vizuálních navigačních
                      systémů.
                    </p>
                    <p>
                      Prověření přístupnosti jednotlivých částí dle návrhu (např. simulace pohybu
                      osob na vozíku).
                    </p>
                  </div>
                </li>
                <li className="mt-3">
                  Omezení během zkušebního provozu:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>Popis možných omezení (např. částečné uzavření určitých částí budovy).</p>
                  </div>
                </li>
              </ul>
            </li>

            <li className="mt-3">
              Vliv na okolí
              <ul className="list-disc pl-5">
                <li className="mt-3">
                  Úpravy veřejného prostoru:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>Přístupové chodníky, zajištění bezbariérovosti v přilehlých komunikacích.</p>
                    <p>
                      Dopad na veřejnou infrastrukturu (např. dočasné omezení průchodnosti během
                      výstavby).
                    </p>
                  </div>
                </li>
                <li className="mt-3">
                  Ochrana okolí:
                  <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                    <p>
                      Minimalizace negativních vlivů na okolní prostředí (hluk, prach, přístupová
                      omezení).
                    </p>
                    <p>Zajištění bezpečnosti osob pohybujících se v okolí stavby.</p>
                  </div>
                </li>
              </ul>
            </li>
          </ol>
        </div>
      }
    >
      <div className="sm:col-span-6 p-5 rounded-md">
        <Field
          label="a) celkové řešení přístupnosti se specifikací jednotlivých části, které podléhají požadavkům na přístupnost, včetně dopadů předčasného užívání a
zkušebního provozu a vlivu na okolí"
          name="b3.overallAccessibilityConditions.individualParts.enabled"
          component={RadioInput}
          options={[
            {
              label: 'Ano',
              value: true,
            },
            {
              label: 'Ne',
              value: false,
            },
          ]}
        />
        {formik.values.b3.overallAccessibilityConditions.individualParts.enabled === true && (
          <div className="pl-7">
            <div className="sm:col-span-6 mt-3">
              <Field
                name="b3.overallAccessibilityConditions.individualParts.description"
                label=""
                component={RichTextInput}
                aiHint="celkové řešení přístupnosti se specifikací jednotlivých části, které podléhají požadavkům na přístupnost, včetně dopadů předčasného užívání a
zkušebního provozu a vlivu na okolí - popis "
              />
            </div>
          </div>
        )}
      </div>
      <div className="sm:col-span-6 p-5 rounded-md">
        <Field
          label="b) popis navržených opatření - zejména přístup ke stavbě, prostory stavby a systémy určené pro užívání veřejností"
          name="b3.overallAccessibilityConditions.proposedPrecautionsDescription.enabled"
          component={RadioInput}
          options={[
            {
              label: 'Ano',
              value: true,
            },
            {
              label: 'Ne',
              value: false,
            },
          ]}
        />
        {formik.values.b3.overallAccessibilityConditions.proposedPrecautionsDescription.enabled ===
          true && (
          <div className="pl-7">
            <div className="sm:col-span-6 mt-3">
              <Field
                name="b3.overallAccessibilityConditions.proposedPrecautionsDescription.description"
                label=""
                component={RichTextInput}
                aiHint="popis navržených opatření - zejména přístup ke stavbě, prostory stavby a systémy určené pro užívání veřejností - popis"
              />
            </div>
          </div>
        )}
      </div>
      <div className="sm:col-span-6 p-5 rounded-md">
        <Field
          label="c) popis dopadů na přístupnost z hlediska uplatnění závažných územně technických nebo stavebně technických důvodů nebo jiných veřejných
zájmů."
          name="b3.overallAccessibilityConditions.accessibilityImpactDescription.enabled"
          component={RadioInput}
          options={[
            {
              label: 'Ano',
              value: true,
            },
            {
              label: 'Ne',
              value: false,
            },
          ]}
        />
        {formik.values.b3.overallAccessibilityConditions.accessibilityImpactDescription.enabled ===
          true && (
          <div className="pl-7">
            <div className="sm:col-span-6 mt-3">
              <Field
                name="b3.overallAccessibilityConditions.accessibilityImpactDescription.description"
                label=""
                component={RichTextInput}
                aiHint="popis dopadů na přístupnost z hlediska uplatnění závažných územně technických nebo stavebně technických důvodů nebo jiných veřejných"
              />
            </div>
          </div>
        )}
      </div>
    </FormSectionTwoColumns>
  )
}
